import { useState, useEffect } from "react";
import { MENU_API, getApiUrl } from "../utils/constants.js";

export default function useRestaurantMenu(resId) {
    const [resInfo, setResInfo] = useState(null);

    useEffect(() => {
        const fetchMenu = async () => {
            try {
                const endpoint = MENU_API + resId + "&catalog_qa=undefined&submitAction=ENTER";
                const response = await fetch(getApiUrl(endpoint));
                const json = await response.json();
                setResInfo(json);
            } catch (err) {
                console.error("Failed to fetch menu:", err);
            }
        };

        if (resId) {
            fetchMenu();
        }
    }, [resId]);

    return resInfo;
}
